import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const endoflifeDate = defineConnector({
  identifier: "endoflifeDate",
  name: "endoflife.date",
  tagLine: "Product support and end-of-life dates",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://endoflife.date/api/v1"),
  auth: headerAuth([]),
  steps: [
    {
      title: "Set up endoflife.date",
      items: [
        {
          kind: "markdown",
          content:
            "This public API requires no credentials. Use the default API URL. See the [API documentation](https://endoflife.date/docs/api/v1).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://endoflife.date/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the documented production v1 server at https://endoflife.date/api/v1. No tenant selection or regional API host is documented.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://endoflife.date/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/",
      ...{ method: "GET" },
    }),
  },
});
